import React from 'react';
import { Divider, Collapse } from 'antd';

const RightToWork = () => {
  return (
    <>
      <Collapse accordion defaultActiveKey="1">
        <Collapse.Panel header={<span>Right to work</span>} key="1">
          <h3>
            If you do not have an automatic right to work in the UK then we will
            need proof of your &apos;Right to Work&apos; in the UK.
          </h3>
          <p>
            Therefore, in order that potential employers comply with the
            following legislation
          </p>
          <ol>
            <li>Immigration, Asylum and Nationality Act 2006</li>
            <li>Section 24B of the Immigration Act 1971</li>
            <li>Schedule 6 of the Immigration Act 2016</li>
          </ol>
          <h3>
            MyShifts need to check your current &apos;Right to Work&apos; in the
            UK
          </h3>
          <p>This means you can either:</p>
          <ol>
            <li>
              Provide MyShifts with your &apos;Right to Work&apos; Share Code.
              We can then check this on the UK Government website.
            </li>
            <li>
              Send the Right to Work document to our registered office, or
              <a href="mailto:righttowork@my-shifts.co.uk">email</a> it and we
              will verify that this is you and that it is genuine and send them
              back to you.
            </li>
            <li>Email the document to us.</li>
          </ol>
        </Collapse.Panel>
      </Collapse>
      <Divider />
    </>
  );
};

RightToWork.propTypes = {};

export default RightToWork;
